import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./transaction_result.js";
//#region src/transaction_result_helper.ts
var transaction_result_helper_exports = /* @__PURE__ */ __exportAll({ stringFromEnum: () => stringFromEnum });
function stringFromEnum(result) {
	switch (result) {
		case 0: return "none";
		case 1: return "approved";
		case 2: return "partially-approved";
		case 3: return "declined";
		case 4: return "offline-approved";
	}
}
//#endregion
export { stringFromEnum, transaction_result_helper_exports };

//# sourceMappingURL=transaction_result_helper.js.map